import axios from 'axios'
import { APP_CONFIG } from '../config/app'

const instance = axios.create({
  baseURL: APP_CONFIG.SERVER_URI,
  headers: {
    'Cache-Control': 'no-cache',
    common: {
      'x-api-key': APP_CONFIG.X_API_KEY
    }
  }
})

instance.interceptors.request.use((config) => {
  const workflow_channel = sessionStorage.getItem('workflowChannel')

  if (workflow_channel) {
    config.headers['workflow-channel'] = workflow_channel
  }

  if (workflow_channel === 'MTA') {
    config.baseURL = APP_CONFIG.MI_TIENDA_SERVER_URI
  } else {
    config.baseURL = APP_CONFIG.SERVER_URI
  }
  return config
})

export { instance as axios }
